import { GameWeek, SeasonID, TeamID } from 'types';

export type TeamLoaderPayload = {
  year: SeasonID;
  weekNum: GameWeek;
  teamId: TeamID;
};

export const teamLoader = async ({ params }: any): Promise<TeamLoaderPayload | Response> => {
  const yearId = params.yearId;
  const weekId = params.weekId;
  const teamId = params.teamId;

  // const msg = `${Emojis.eyes} %c teamStatsLoader %c %c ${yearId} %c %c ${weekId} %c`;
  // console.log(msg, LocationCls, '', ValueCls, '', ValueCls, '');

  // const msg = `${Emojis.eyes} %c teamStatsLoader %c %c ${location.href} %c`;
  // console.log(msg, LocationCls, '', ValueCls, '');

  return {
    year: yearId,
    weekNum: weekId,
    teamId: teamId,
  };
};
